import {Injectable} from '@angular/core';
import {BehaviorSubject, take, tap} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {toSignal} from "@angular/core/rxjs-interop";
import {APIRequestResources, CachedAPIRequest} from "../../../../../core";
import {LabelTypeGetAllDTO} from "../interface/label-type.interface";

@Injectable({
    providedIn: 'root'
})
export class LabelTypesService extends CachedAPIRequest {
    

    private readonly $all = new BehaviorSubject<LabelTypeGetAllDTO[]>([]);
    all = toSignal(this.$all, {initialValue: []})

    constructor(protected override http: HttpClient, private router: Router) {
        super(http, APIRequestResources.LabelTypesService)
        this.getAll().pipe(take(1)).subscribe()
    }

    getAll = (refresh = true) => {
        return this.get<LabelTypeGetAllDTO[]>({
            endpoint: `all`,
        }, refresh ? 'freshness' : 'performance')
            .pipe(
                tap((res) => this.$all.next(res.data)),
            )
    }


}
